import HttpMethod from "../../Constants/Base/HttpMethod";
import {request} from "../../Base/HTTP";

export async function fetchExchangeRate(fromCode, toCode, date) {
    return await request(`/api/exchange_rate/${fromCode}/${toCode}/${date.toISOString().slice(0, 10)}`, HttpMethod.GET);
}